import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Divider,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const PermisosMovilList = ({ permisosMovil, onPermisosMovilChange }) => {
  const [expanded, setExpanded] = useState(null);
  const [permisosMovilState, setPermisosMovilState] = useState([]);

  useEffect(() => {
    setPermisosMovilState(permisosMovil);
  }, [permisosMovil]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeCheck = (idPermisoMovil) => (event) => {
    const { checked } = event.target;

    const updatePermisosMovil = (permisosMovil) => {
      return permisosMovil.map((permisoMovil) => {
        if (permisoMovil.idPermisoMovil === idPermisoMovil) {
          return { ...permisoMovil, estatus: checked };
        } else if (
          permisoMovil.inverseIdPermisoMovilPadreNavigation.length > 0
        ) {
          return {
            ...permisoMovil,
            inverseIdPermisoMovilPadreNavigation: updatePermisosMovil(
              permisoMovil.inverseIdPermisoMovilPadreNavigation
            ),
          };
        }
        return permisoMovil;
      });
    };

    const updatedPermisosMovil = updatePermisosMovil(permisosMovilState);
    setPermisosMovilState(updatedPermisosMovil);
    onPermisosMovilChange(updatedPermisosMovil);
  };

  const renderPermisoMovil = (permisoMovil) => {
    return (
      <Accordion
        key={permisoMovil.idPermisoMovil}
        expanded={expanded === `panel-${permisoMovil.idPermisoMovil}`}
        onChange={handleChange(`panel-${permisoMovil.idPermisoMovil}`)}
        sx={{
          overflow: "hidden",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: 2,
          width: "100%",
          margin: "auto",
          maxWidth: "100%",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormControlLabel
            control={
              <Checkbox
                checked={permisoMovil.estatus}
                onChange={handleChangeCheck(permisoMovil.idPermisoMovil)}
                name={`checkbox-${permisoMovil.idPermisoMovil}`}
              />
            }
            label={permisoMovil.descripcion}
          />
        </AccordionSummary>
        <AccordionDetails>
          <List style={{ width: "100%" }}>
            {permisoMovil.inverseIdPermisoMovilPadreNavigation.length > 0 &&
              permisoMovil.inverseIdPermisoMovilPadreNavigation.map(
                (subPermisoMovil, index) => (
                  <React.Fragment key={subPermisoMovil.idPermisoMovil}>
                    <ListItem>
                      <Checkbox
                        checked={subPermisoMovil.estatus}
                        onChange={handleChangeCheck(
                          subPermisoMovil.idPermisoMovil
                        )}
                        name={`checkbox-${subPermisoMovil.idPermisoMovil}`}
                      />
                      <ListItemText primary={subPermisoMovil.descripcion} />
                    </ListItem>
                    {index !==
                      permisoMovil.inverseIdPermisoMovilPadreNavigation.length -
                        1 && <Divider />}
                  </React.Fragment>
                )
              )}
          </List>
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <div>
      {permisosMovilState.map((permisoMovil) =>
        renderPermisoMovil(permisoMovil)
      )}
    </div>
  );
};

export default PermisosMovilList;
